import React from 'react'
import { Helmet } from 'react-helmet-async';
import { Stack, Card, CardHeader, Divider } from '@mui/material';

import { BusinessBasicDetails } from '../../common/business/BusinessBasicDetails';
import { BusinessCorporateProfile } from '../../common/business/BusinessCorporateProfile';
import Workflows from '../../common/workflow/Workflows';

function AdminViewBusiness() {
  return (
    <>
    <Helmet><title>BVT Admin - Users</title></Helmet>
    <Stack spacing={3}>
      <BusinessBasicDetails/>
      <BusinessCorporateProfile/>
      <Card>
        <CardHeader 
          title="Workflow History" 
          subheader="All workflow assignments"
        />
        <Divider />
        <Workflows/>
      </Card>
    </Stack>
    </>
  )
}

export default AdminViewBusiness